import React, {useContext} from "react";
import {Api} from '../api/Api';
import {useErrorWebhook} from "./useErrorWebhook";
import VisitorParamsContext from "../Contexts/VisitorParams";

export const useSkippedLeads = () => {
  const { visitorParameters } = useContext(VisitorParamsContext);
  const uuid=visitorParameters.visitor_parameters.uuid;
  const { ErrorWebhookTrigger } = useErrorWebhook();
  
    const skippedLeads = async (type,uuid,page_name) => {
      const response = await Api.post("api/v1/skipped-leads", {
        uuid,
        type,
        page_name
      }).catch(function (error) {
        const erroMessage = {
          serviceName : 'SKIPPED LEADS',
          errorReason:error.message,
          errorCode:error.code,
          uuid:uuid
        }
        ErrorWebhookTrigger(erroMessage);
      });
      return response;
    };

    const skippedLeadsFLP = async (type,followup_data,page_name) => {
      const response = await Api.post("api/v1/flp-skipped-leads", {
        followup_data,
        type,
        page_name
      }).catch(function (error) {
        const erroMessage = {
          serviceName : 'FLP SKIPPED LEADS',
          errorReason:error.message,
          errorCode:error.code,
          uuid:uuid
        }
        ErrorWebhookTrigger(erroMessage);
      });
      return response;
    };
    return { skippedLeads,skippedLeadsFLP };
  };
  